import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  position: relative;\n  flex-shrink: 0;\n  box-sizing: content-box;\n  ", ";\n  ", "\n  ", "\n  ", "\n  & > * {\n    flex-shrink: 0;\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { getPx } from '../../../helpers/common';
import { isDefined } from '../../../helpers/defined';
import { alignStyle } from '../style';
import { absoluteCenteredStyle } from '../../../tokens/centered';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../../../helpers/media-style';
import { translateY } from '../../../style/translate-y';
export var InfoWithIconsPlaceholder = styled.span(_templateObject(), function (_ref) {
  var $vertical = _ref.$vertical;
  return styleForBreakpoints($vertical, function ($vertical) {
    return $vertical ? "width: 0;" : "height: 0;";
  });
}, function (_ref2) {
  var $iconWidth = _ref2.$iconWidth,
      $iconHeight = _ref2.$iconHeight,
      $vertical = _ref2.$vertical;
  return styleArrayForBreakpoints([$iconWidth, $iconHeight, $vertical], function (_ref3) {
    var $iconWidth = _ref3[0],
        $iconHeight = _ref3[1],
        $vertical = _ref3[2];
    return $vertical ? "height: " + getPx($iconHeight) + ";" : "width: " + getPx($iconWidth) + ";";
  });
}, function (_ref4) {
  var $iconTopPosition = _ref4.$iconTopPosition;
  return isDefined($iconTopPosition) ? translateY($iconTopPosition) : '';
}, alignStyle, absoluteCenteredStyle);